import {Component, OnDestroy, Output} from '@angular/core';
import {DocumentsService} from '../../../services/documents.service';
import {Document} from '../../../types/document-data.types';
import { AuthenticationService } from '../../../services/authentication.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'documents-list',
    templateUrl: './documents-list.component.html',
    styleUrls: ['./documents-list.component.scss']
})
export class DocumentsListComponent implements OnDestroy {
    public documentsList: Array<Document> = [];

    private currentDirectorySubscription;
    private dataToogledSubscription;
    public fileIsOver: boolean = false;
    @Output() public options = {
        readAs: 'DataURL'
    };

    constructor(public ds: DocumentsService,
                public authenticationService: AuthenticationService
    ) {
        this.ds.urlService.queryParams['order-by'] = 'name|asc';
        const qp: any = this.ds.urlService.getQueryParamsJson();
        const documentId = qp.id;
        if (documentId) {
            this.ds.fetchDocument(documentId).subscribe(doc => {
                this.ds.toggleDetailedView(doc)
            }, error => {
                if (error.status === 404) {
                    toastr.error('The file has been deleted.');
                }
            })
        }

        this.currentDirectorySubscription = this.ds.currentDirectoryId.subscribe((currentDirectoryId: number) => {
            if (currentDirectoryId) {
                this.ds.getDocumentsByParentId(currentDirectoryId).subscribe((documents) => {
                    this.documentsList = documents;
                    if(this.ds.selectedItemData) {
                        const match = this.documentsList.find(d => d.id == this.ds.selectedItemData.id);
                        if (match) {
                            (<any>match).checked = true;
                            this.ds.selectedItemData = null;
                            this.ds.toggleDetailedView(match);
                        } else if (!documentId) {
                            this.ds.toggleDetailedView(null);
                        }
                    }
                    if($('.table')[0])
                        $('.table')[0].scrollIntoView();
                });
            }
        });

        this.ds.urlService.onUrlChange.subscribe(() => {
            this.ds.goTo();
            this.ds.isDocumentDetailedModalShow = false;
        });
        this.dataToogledSubscription = this.ds.dataToggled.subscribe(
            () => this.documentsList.forEach(item => (<any>item).checked = false)
        );
    }

    ngOnDestroy(): void {
        this.currentDirectorySubscription.unsubscribe();
        this.dataToogledSubscription.unsubscribe();
        this.ds.currentDirectoryId = new BehaviorSubject<number>(null);
    }

    orderBy(orderBy: string, $event) {
        if (this.documentsList.length < 2) return;
        this.ds.urlService.orderBy(orderBy, $event);
    }

    public showDocument(document: Document) {
        document = new Document(document);
        if (document.isImage) {
            this.ds.showImage(document);
        } else {
            document.show();
        }
    }

    public fileOver(fileIsOver: boolean): void {
        this.fileIsOver = fileIsOver;
    }

    public onFileDrop(file): void {
        file.preventDefault();
        if(file.dataTransfer.files && file.dataTransfer.files.length) {
            this.ds.isDocumentsLoading = true;
            let files = [];
            for (let i = 0; i < file.dataTransfer.files.length; i++) {
                const blobFile = {
                    corporationNumbers: this.ds.path[this.ds.path.length - 1].corporationNumbers,
                    buildings: this.ds.path[this.ds.path.length - 1].buildings,
                    file: file.dataTransfer.files[i],
                    permissions: this.ds.path[this.ds.path.length - 1].documentsPermissions.map((item: any) => {
                        return {
                            permission: item.permission
                        };
                    }),
                    isPublic: this.ds.path[this.ds.path.length - 1].isPublic
                };
                files.push(blobFile);
            }
            this.ds.uploadMultipleFiles(files).subscribe(message => {
                toastr.success('The file has been uploaded successfully.');
                this.ds.isDocumentsLoading = false;
                this.ds.goTo();
            }, error => {
                toastr.error('Some of the files failed to upload.');
                this.ds.isDocumentsLoading = false;
                this.ds.goTo();
            });
        }
    }

    public trackByFn(index, item) {
        return item.id
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-list/documents-list.component.ts